// extracted by mini-css-extract-plugin
module.exports = {"indicator":"TagTypeIndicator_indicator_2VOBD","indicatorMesh":"TagTypeIndicator_indicatorMesh_1VsDb","spinAround":"TagTypeIndicator_spinAround_LZpSN"};